import { get } from 'lodash-es';
import type { EntityAdminRecord } from '../../types';
import { isNotDivider } from '../InputsAndDropdownsDrawer/components/dividerUtils';
import type { InputsAndDropdownsDrawerOption } from '../InputsAndDropdownsDrawer/types';

export const hideDrawerOption = <TDrawerRecord extends EntityAdminRecord>(
  option: InputsAndDropdownsDrawerOption<TDrawerRecord>,
  form: TDrawerRecord,
  originalEntity: TDrawerRecord | undefined
): boolean => {
  // If hiddenIfMissing is true, hide if value is null, undefined, or empty string
  if (isNotDivider(option) && option.hiddenIfMissing) {
    const value = get(form, option.field);
    return value == null || value === '';
  }
  return option.getIsHidden?.(form, originalEntity) ?? false;
};
